{
  "error": {
    "server_connection_failed": "Falló la conexión al servidor.  "
  },
  "term": {
    "affects_all_instances": "Afecta a {count} instancias",
    "affects_this_instance_only": "Afectar sólo a esta instancia",
    "application": "Aplicación",
    "attributes": "Atributos",
    "bytes": "Bytes",
    "cancel": "Cancelar",
    "clear": "Borrar",
    "cleared": "Borrado",
    "close": "Cerrado",
    "confirm": "Confirmar",
    "context_refresh": "Actualizar contexto",
    "context_refresh_failed": "Fallido",
    "context_refreshed": "Contexto actualizado",
    "delete": "Eliminar",
    "deleted": "Eliminado",
    "duration": "Duración",
    "event": "Evento",
    "ever": "Siempre",
    "execute": "Ejecutar",
    "executing": "Ejecutando...",
    "execution_failed": "Ejecución fallida",
    "execution_successful": "Ejecución exitosa",
    "failed": "Fallido",
    "float": "Float",
    "hours": "{count} hora | {count} horas",
    "instance": "Instancia",
    "instances": "Instancias",
    "integer": "Entero",
    "milliseconds": "Milisegundos",
    "minutes": "{count} minuto | {count} minutos",
    "percent": "por ciento",
    "name": "Nombre",
    "operations": "Operaciones",
    "save": "Guardar",
    "stacktrace": "Stacktrace",
    "suppress": "Suprimir",
    "time": "Horario",
    "unsuppress": "Anular",
    "username": "Usuario",
    "go_to_previous_page": "Página anterior",
    "go_to_page_n": "Ir a página {page}",
    "go_to_next_page": "Página siguiente"
  },
  "time_short": {
    "unknown": "unknown",
    "milliseconds": "{count}ms",
    "seconds": "{count}s",
    "minutes": "{count}min",
    "hours": "{count}h",
    "days": "{count}d",
    "weeks": "{count}sem",
    "months": "{count}mes",
    "years": "{count}a"
  }
}
